import { AriaRole } from 'react';
import { HiOutlineMagnifyingGlass, HiXMark } from 'react-icons/hi2';

export interface IDataTableSearchFieldProps {
    /** Набранный текст */
    value: string;
    /** Ввод — на каждый символ */
    onChange: (text: string) => void;
    /** Нажатие «Очистить поиск» (кнопка видна при непустом тексте) */
    onClear: () => void;
    onBlur?: () => void;
    /** Имя поля (`aria-label`) */
    label: string;
    placeholder?: string;
    title?: string;
    maxLength?: number;
    /** Роль корня — `search`, если поле само ориентир поиска на странице */
    role?: AriaRole;
}

/** Поле поиска в виде туллбара DataTable (`.dtb__search`): лупа, ввод, кнопка очистки. Текст и паузу ведёт владелец. */
const DataTableSearchField = ({
    value,
    onChange,
    onClear,
    onBlur,
    label,
    placeholder,
    title,
    maxLength,
    role,
}: IDataTableSearchFieldProps) => (
    <div className="dtb__search" role={role}>
        <HiOutlineMagnifyingGlass aria-hidden />
        <input
            aria-label={label}
            maxLength={maxLength}
            placeholder={placeholder}
            title={title}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onBlur={onBlur}
        />
        {value !== '' && (
            <button type="button" className="dtb__search-clear" aria-label="Очистить поиск" onClick={onClear}>
                <HiXMark aria-hidden />
            </button>
        )}
    </div>
);

export default DataTableSearchField;
